import { createAction, createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ReduxRootState } from "../../shared/redux/store";
import { ReduxSliceState } from "../../shared/types";
import { withPayloadType } from "../../shared/utils";
import { ShipToPatientOrderConfirmation } from "../../api/types";
import { ReduxShipToPatientState, ShipToPatientFormState } from "../types";

const initialState: ReduxShipToPatientState = {
    state: 'READY',
    confirmation: undefined,
    errorMessage: undefined,
};

export const createShipToPatientOrder = createAction('shipToPatient/createShipToPatientOrder', withPayloadType<ShipToPatientFormState>());
export const resetShipToPatientOrder = createAction('shipToPatient/resetShipToPatientOrder');

const shipToPatientSlice = createSlice({
    name: 'shipToPatient',
    initialState,
    reducers: {
        setState: (state, action: PayloadAction<ReduxSliceState>) => {
            state.state = action.payload;
        },
        setConfirmation: (state, action: PayloadAction<ShipToPatientOrderConfirmation | undefined>) => {
            state.confirmation = action.payload;
        },
        setErrorMessage: (state, action: PayloadAction<string | undefined>) => {
            state.errorMessage = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(resetShipToPatientOrder, (state) => {
            state.state = 'READY';
            state.confirmation = undefined;
            state.errorMessage = undefined;
        });
    },
});

export default shipToPatientSlice;

const selectSelf = (state: ReduxRootState) => state.shipToPatient;
export const selectShipToPatientIsBusy = createSelector(selectSelf, self => self.state === 'BUSY');
export const selectShipToPatientIsSuccess = createSelector(selectSelf, self => self.state === 'SUCCESS');
export const selectShipToPatientIsError = createSelector(selectSelf, self => self.state === 'ERROR');
export const selectShipToPatientConfirmation = createSelector(selectSelf, self => self.confirmation);
export const selectShipToPatientErrorMessage = createSelector(selectSelf, self => self.errorMessage);
